import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Component, Inject, OnInit } from "@angular/core";

type DialogData = {
  error: any;
};

@Component({
  selector: 'app-real-estate-form-error-dialog',
  templateUrl: "./real-estate-form-error-dialog.component.html",
  styleUrls: ["./real-estate-form-error-dialog.component.scss"],
})
export class RealEstateFormErrorDialogComponent implements OnInit {
  errors: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<RealEstateFormErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
  }

  ngOnInit(): void {
    if(this.data.error[0] === '[') {
      let error = this.data.error.replace(/\'/g, '"').replace(/%/g, '\'');
      this.errors = JSON.parse(error)
    } else {
      this.errors.push(this.data.error);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
